import moment from 'moment';

export type DashboardRange =
  | 'Today'
  | 'Yesterday'
  | 'Weekly'
  | 'Monthly'
  | 'Yearly';

export type DashboardPeriodKey =
  | 'today'
  | 'yesterday'
  | 'this_week'
  | 'this_month_mtd'
  | 'this_year_ytd'
  | 'last_7_days'
  | 'last_30_days'
  | 'custom_range';

export const DASHBOARD_RANGE_TO_PERIOD_KEY: Record<
  DashboardRange,
  DashboardPeriodKey
> = {
  Today: 'today',
  Yesterday: 'yesterday',
  Weekly: 'this_week',
  Monthly: 'this_month_mtd',
  Yearly: 'this_year_ytd',
};

export const getDashboardDateRange = (selection: DashboardRange) => {
  switch (selection) {
    case 'Today':
      return {
        start: moment().startOf('day').toISOString(),
        end: moment().endOf('day').toISOString(),
        periodKey: DASHBOARD_RANGE_TO_PERIOD_KEY.Today,
      };
    case 'Yesterday':
      return {
        start: moment().subtract(1, 'day').startOf('day').toISOString(),
        end: moment().subtract(1, 'day').endOf('day').toISOString(),
        periodKey: DASHBOARD_RANGE_TO_PERIOD_KEY.Yesterday,
      };
    case 'Weekly':
      return {
        start: moment().startOf('week').toISOString(),
        end: moment().endOf('day').toISOString(),
        periodKey: DASHBOARD_RANGE_TO_PERIOD_KEY.Weekly,
      };
    case 'Monthly':
      return {
        start: moment().startOf('month').toISOString(),
        end: moment().endOf('day').toISOString(),
        periodKey: DASHBOARD_RANGE_TO_PERIOD_KEY.Monthly,
      };
    case 'Yearly':
      return {
        start: moment().startOf('year').toISOString(),
        end: moment().endOf('day').toISOString(),
        periodKey: DASHBOARD_RANGE_TO_PERIOD_KEY.Yearly,
      };
  }
};

export const getDashboardComparisonPeriodLabel = (
  selection: DashboardRange,
) => {
  switch (selection) {
    case 'Today':
      return 'yesterday';
    case 'Yesterday':
      return 'previous day';
    case 'Weekly':
      return 'last week';
    case 'Monthly':
      return 'last month';
    case 'Yearly':
      return 'last year';
  }
};

/** Dropdown-facing label for chart titles, e.g. "This Month". */
export const DASHBOARD_RANGE_DISPLAY_LABEL: Record<DashboardRange, string> = {
  Today: 'Today',
  Yesterday: 'Yesterday',
  Weekly: 'This Week',
  Monthly: 'This Month',
  Yearly: 'This Year',
};

export const getDashboardRangeDisplayLabel = (selection: DashboardRange) =>
  DASHBOARD_RANGE_DISPLAY_LABEL[selection];
